import { IHistoryPractice } from '@app/api/academic.api';
import { Descriptions, Table } from 'antd';
import { useTranslation } from 'react-i18next';

interface ISubScore {
  score: number;
  break_error_details?: {
    word: string;
    index: number;
    times: number;
    silence_duration: number;
    accepted_max_duration: number;
    accepted_min_duration: number;
  }[];
}

interface SpeakReadAloudProps {
  data: IHistoryPractice;
}

// Hàm kiểm tra kiểu dữ liệu
function isSubScore(value: unknown): value is ISubScore {
  return typeof value === 'object' && value !== null && 'score' in value;
}

// Hàm định dạng từ
function formatWordData(
  words: {
    word: string;
    times: number;
  }[],
): string {
  return words
    .map((item) => {
      const cleanWord = item.word.trim().replace(/[,\.!?]$/, '');
      const separator = '/'.repeat(item.times);
      return `${cleanWord} ${separator}`;
    })
    .join(' ')
    .trim();
}

export const TableCollapseDetail: React.FC<SpeakReadAloudProps> = ({ data }) => {
  const { t } = useTranslation();
  const rawScore = data?.score?.score || {};
  const flatScore: Record<string, number> = {};
  let dataFluency: ISubScore['break_error_details'] = [];

  // Làm phẳng điểm số và lấy break_error_details nếu có
  Object.entries(rawScore).forEach(([key, value]) => {
    if (isSubScore(value)) {
      flatScore[key] = value.score;
      if (key === 'fluency') {
        dataFluency = value.break_error_details ?? [];
      }
    } else if (typeof value === 'number') {
      flatScore[key] = value;
    }
  });

  const columns = Object.keys(flatScore).map((key) => ({
    title: t(`page.results.detailTable.${key}`),
    dataIndex: key,
    key,
  }));

  const dataScore = [{ key: 1, ...flatScore }];

  const formatCorrectAnswer = () => {
    if (data.type.startsWith('SPEAKING')) {
      return formatWordData(dataFluency || []);
    }
    return data.correct_answer;
  };

  return (
    <Descriptions bordered column={1} title={t('page.results.answerDetail')} size="small">
      <Descriptions.Item label={t('page.results.correctAnswer')}>{formatCorrectAnswer()}</Descriptions.Item>
      <Descriptions.Item label={t('page.results.yourAnswer')}>
        {data.type.startsWith('SPEAKING') ? (
          <audio controls crossOrigin="anonymous">
            <source src={`${process.env.REACT_APP_BASE_URL}${data.answer}`} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        ) : (
          data.answer
        )}
      </Descriptions.Item>
      <Descriptions.Item label={t('page.results.score')}>
        <Table columns={columns} dataSource={dataScore} pagination={false} />
      </Descriptions.Item>
    </Descriptions>
  );
};
